import React from "react";
import "react-tabs/style/react-tabs.css";
import { Button } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CardBody } from "reactstrap";
import EditIcon from '@material-ui/icons/Create';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import SimpleReactValidator from 'simple-react-validator';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dateFormat from 'dateformat';
import { connect } from "react-redux";
import 'moment/locale/fr.js' // or 'rc-datepicker/node_modules/moment/locale/fr.js' if you don't have it in your node_modules folder
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import moment from "moment";
import { toast } from 'react-toastify';

class RegisterMaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [""],
      adminPass: "", statusEdit: [], statusUpdate: false, remarks: "", status: "",userparentcomp:"",
      fromDate: "", toDate: "", fromDate1: "", toDate1: "", pricePerKL: "", selectDate: "", selectDate1: "", contractPriceToDate: "", contractPriceFromDate: ""
      ,childcategory: "",parentdataid: "",
	  parentcategorystatus:"",
	  parenteditid:"",
    };
    this.submitHandler = this.submitHandler.bind(this);
	this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    this.pdValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
  }

  submitHandler = () => {
    this.props.history.path("/user/user-create")
  }


  nextPath(path) {
    this.props.history.push({ pathname: path });
  }

  componentDidMount() {
    const url = process.env.REACT_APP_NODE_ENV + "/api/compliant/parentlist";
    fetch(url,{
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
        // console.log(data.data)
       this.setState({ userData: data.data })
    })
  }

  editStatusHandler = () => {
    const doesToggle = this.state.editStatus;
    this.setState({ editStatus: !doesToggle });
  };
  editStatuschild = value => {
    const doesToggle = this.state.editStatuss;
    this.setState({ parentcategorystatus: value[3], userparentcomp: value[1], parenteditid:value[0], editStatuss: !doesToggle });
    // alert(value[3])
    // alert(this.state.parentcategorystatus)
   // this.editparentdata(value)

  }

  save = () => {
    
    if (this.validator.allValid()) {
      this.setState({ editStatus: false })
      let postOrderData = "";
      if (this.state.userparentcomp) {

        postOrderData = { 
            "parent_category" : this.state.userparentcomp,
            "status":this.state.parentcategorystatus === "" ? 1:this.state.parentcategorystatus
           }
        console.log(postOrderData)
        fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/createparent', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify(postOrderData)
        }).then((res) => res.json())
          .then((data) => {
            console.log(data)
            this.componentDidMount()
            toast.success("parent  Category Inserted Successfully", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000
              });
          })
          .catch((err) => console.log(err))
      }
      else {
        this.componentDidMount();
      }
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  
  editParent = () => {
    // alert('test')
    if (this.validator.allValid()) {
      this.setState({ editStatuss: false })
      let postOrderData = "";
      if (this.state.userparentcomp) {

        postOrderData = {
            "parent_id" : this.state.parenteditid,
            "parent_category" : this.state.userparentcomp,
            "status":this.state.parentcategorystatus
           }
        console.log(postOrderData)
        fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/editparent', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify(postOrderData)
        }).then((res) => res.json())
          .then((data) => {
            console.log(data)
            this.componentDidMount()
            toast.success("Parent category updated Successfully", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000
              });
          })
          .catch((err) => console.log(err))
      }
      else {
        this.componentDidMount();
      }
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  
  savechild = () => {
   console.log(this.state.childcategory , this.state.parentdataid)


   let postOrderData = "";
   if (this.state.childcategory) {

     postOrderData = { 
        "parent_id":"1",
         "child_category" : this.state.childcategory,
         "status":this.state.parentcategorystatus
        }
     console.log(postOrderData)
     fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/createchild', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
         'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
       },
       body: JSON.stringify(postOrderData)
     }).then((res) => res.json())
       .then((data) => {
         this.componentDidMount()
         this.setState({ editStatuss: false, statusUpdate: false });
         toast.success("Child Category Inserted Successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000
          });
       })
       .catch((err) => console.log(err))
   }
   else {
     this.componentDidMount();
   }

  }
  onchangeuser =(e) => {
    this.setState({ userparentcomp: e.target.value});
  }
  
  handleSelectStatus =(e) => {
	  // alert(e.target.value)
    this.setState({ parentcategorystatus: e.target.value});
  }
  
  // handleSelectStatus = selectedOption => { 
  // alert(selectedOption.id)
	// switch (selectedOption.id) {
		// case "parentcategorystatus":
			// this.setState({ parentcategorystatus: selectedOption.value })
			// break;
      // default: break;
    // }
// }
  
  handleformdata = (e) => {
    
   this.setState({ childcategory : e.target.value})

  }
  handleEditFormFields = (event) => { 
    this.setState({ parentdataid : event.target.value })
  }

  popUpCancel = () => {
    this.setState({ editStatus: false, statusUpdate: false });
  }
  popUpCancel1 = () => {
    this.setState({ editStatuss: false, statusUpdate: false });

  }

  handleUserFormFields = event => {
    this.pdValidator.showMessageFor(event.target.name)
    switch (event.target.id) {
        case "ufirstName":
            this.setState({ userFirstName: event.target.value });
            break;
        case "ulastName":
            this.setState({ userLastName: event.target.value });
            break;
      case "pdToDate":
        this.setState({ toDate: event.target.value, statusUpdate: true });
        break;
      case "pdPricePerKL":
        this.setState({ pricePerKL: event.target.value, statusUpdate: true });
        break;
      default:
        break;
    }
  };

  handleChange2 = date => {
    this.setState({ contractPriceFromDate: date, statusUpdate: true });
  };

  handleChange3 = date => {
    this.setState({ contractPriceToDate: date, statusUpdate: true });
  };

  render() {
    let parent_data = this.state.userData.map(data => (
        <option key={data.id} value={data.id}>{data.parent_category}</option>
      ))

    let statusEdit = (
      <div className="kt-wizard-v1__form">
        <div className="row">
				
			  <div className="col-lg-8">
				<label><b>Parent Category</b></label>
				<div className="form-group">
					<input type=" text" className="form-control" pattern="[A-Za-z]{3}" required name="userparentcomp" id="userparentcomp" placeholder="parent Category" onChange={this.onchangeuser} />
					{
						this.validator.message('parent Category', this.state.userparentcomp, 'required')
					}
				</div>
				
			  </div>
				<div className="col-lg-8">
                  <label> <b>Status</b> </label><select id="parentcategorystatus"  name="parentcategorystatus" className="form-control" onChange={this.handleSelectStatus} >
                    <option value="1">Active</option>
                    <option value="2">InActive</option>
                  </select>     
				</div>
				
         
          </div>
        <br                  /><br />
       
      </div>)

let statusEdits = (
    <div className="kt-wizard-v1__form">
        <div className="row">
			  <div className="col-lg-8">
				<label><b>Parent Category</b></label>
				<div className="form-group">
					<input type=" text" className="form-control" pattern="[A-Za-z]{3}" required name="userparentcomp" id="userparentcomp" placeholder="parent Category" value={this.state.userparentcomp} onChange={this.onchangeuser} />
					{
						this.validator.message('parent Category', this.state.userparentcomp, 'required')
					}
				</div>
			  </div>
			<div className="col-lg-8">
                  <label> <b>Status</b> </label><select id="parentcategorystatus"  name="parentcategorystatus" className="form-control" value={this.state.parentcategorystatus} onChange={this.handleSelectStatus} >
                    <option value="1">Active</option>
                    <option value="2">InActive</option>
                  </select>     
				</div>
          </div><br/><br />
     
    </div>)


    let dataArray = [];
    this.state.userData.map((data) => {
		// if (data.user !== undefined) {
		let variant = "";
		let statusdata = "";
		if(data.status === "2") { variant = "danger";  statusdata = "InActive" }
			else { variant = "success" ; statusdata = "Active" }
		let mdData = {
			key: data.id, id: data.id, parentCategory: data.parent_category, createdAt: data.createdAt, Status: <Badge pill variant={variant}>{statusdata}</Badge>,Statusvalue:data.status, data  };
			dataArray.push(mdData);
		// }
    });


    const columns = [
      {
        name: "id",
        label: "id",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "parentCategory",
        label: "Parent Complaint",
        options: {
          filter: true,
          sort: true,
        }
      },
	   {
        name: "Status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
	   {
        name: "Statusvalue",
        label: "Statusvalue",
        options: {
          filter: true,
          sort: true,
		  display: false,
        }
      },
      {
        name: "createdAt",
        label: "Created At",
        options: {
          filter: true,
          sort: true,
        }
      },	 
       {
         name: "actions",
         label: "Actions",
         options: {
           filter: false,
           sort: false,
           customBodyRender: (value, tableMeta, updateValue) => {
			   console.log(value)
			   console.log(tableMeta.rowData)
             return (
               <><Tooltip title="Edit Status"><IconButton>
               <EditIcon onClick={() => this.editStatuschild(tableMeta.rowData)} /></IconButton></Tooltip>{value} </>
            );
          }
         }
       }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false
    };

    let PriceMasterTable = (<Card>
      <Card.Body>
        <div>
          <Button className="float-right"
            variant="outline-success"
            style={{ marginTop: "10px", width: "150px", marginRight: "25px" }}
            onClick={() => this.editStatusHandler()}>
            Add parent
 </Button> </div>
        <MUIDataTable
          data={dataArray}
          columns={columns}
          options={options} />
      </Card.Body>
    </Card>);

    
    

    let editStatuss = null;
    if (this.state.editStatus) {
      editStatuss = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Add Parent Category</ModalHeader>
              <ModalBody>
                {statusEdit}
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.save()}>
                  Save
            </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }
    
let editStatusss = null;
    if (this.state.editStatuss) {
      editStatusss = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Edit Parent Category</ModalHeader>
              <ModalBody>
                {statusEdits}
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.editParent()}>
                  Save
            </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel1()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }



    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>Parent Compliant</Breadcrumb.Item>
        </Breadcrumb>
        {editStatuss} 
        {editStatusss}
       

        <div>
          {PriceMasterTable}
        </div>
      </>
    );
  }
}

export default RegisterMaster;
